export const TASK_ESTIMATE_CALCULATION_TYPES = {
  OFF: 'Off',
  TASKESTIMATED: 'TaskEstimatedHours',
  TASKASSIGNMENT: 'TaskAssignmentEstimatedHours'
};
